import PointOfViewSectionBottomContent from "./bottom-content";
import PointOfViewSectionTopContent from "./top-content";

const PointOfViewSection = () => {
  return (
    <section className="flex flex-col items-center bg-background-primary-dark-dark text-light
      px-8 py-16 md:p-12 space-y-10 md:space-y-20">
      <PointOfViewSectionTopContent />
      <PointOfViewSectionBottomContent />
    </section>
  );
};

export default PointOfViewSection;
